import Flex from 'components/shared/Flex';
import Heading from 'components/shared/Heading';
import Text from 'components/shared/Text';

type TitleProps = {
  title: string;
  description?: string;
  titleAction?: React.ReactNode;
};

const Title = ({ title, description, titleAction }: TitleProps) => {
  return (
    <Flex direction="column" align="start">
      <div className="flex items-center gap-3">
        <Heading size="5" weight="regular">
          {title}
        </Heading>
        {titleAction}
      </div>
      <Text size="3" className="text-gray-11 h-6">
        {description || null}
      </Text>
    </Flex>
  );
};

type PageHeaderProps = {
  title: string;
  description?: string;
  titleAction?: React.ReactNode;
  children?: React.ReactNode;
};

const PageHeader = ({ children, title, description, titleAction }: PageHeaderProps) => {
  return (
    <Flex align="center" justify="between" width="100%" pt="3" pb="3">
      <Title title={title} description={description} titleAction={titleAction} />
      <Flex align="center" gap="3">
        {children}
      </Flex>
    </Flex>
  );
};

export default PageHeader;
